import axios from 'axios';

import { API_BASE_URL as BASE } from './apiConfig';

// 개발 환경에서 REACT_APP_OPEN_API_TEST_URL이 설정된 경우 운영 서버 직접 호출
// → 로컬에서 실제 고객용 Open API를 테스트할 때 사용
// 미설정 또는 운영 빌드: 상대 경로 사용 (CloudFront → ALB 라우팅)
const OPEN_API_BASE = process.env.REACT_APP_OPEN_API_TEST_URL || BASE;
const API_BASE_URL = `${OPEN_API_BASE}/api/open/alt`;

const normalizeApiKey = (apiKey: string) => {
  return apiKey.trim();
};

export const apiOpenAlt = {
  // 사용량/쿼터 조회
  async getUsage(apiKey: string) {
    const res = await axios.get(`${API_BASE_URL}/usage`, {
      headers: { 'X-API-KEY': normalizeApiKey(apiKey) }
    });
    return res.data;
  },

  // ALT 생성 요청
  async generateAlt(apiKey: string, imageUrl: string) {
    const res = await axios.post(`${API_BASE_URL}/generate`, { imageUrl }, {
      headers: { 'X-API-KEY': normalizeApiKey(apiKey) }
    });
    return res.data;
  },

  // ALT 결과 조회
  async getResult(apiKey: string, requestId: string) {
    const res = await axios.get(`${API_BASE_URL}/result/${requestId}`, {
      headers: { 'X-API-KEY': normalizeApiKey(apiKey) }
    });
    return res.data;
  }
};
